module.exports = __webpack_public_path__ + "993868162b391b10f8f722ffd11522a8.png";